const { icons } = require('./constant');

const documents = {
	id: 'document_master',
	title: 'Document',
	type: 'collapse',
	icon: icons.IconDocument,
	children: [
		{
			id: 'documentCategories',
			title: 'Document Categories',
			type: 'item',
			url: '/documentCategories',
			icon: icons.IconOccupation,
			breadcrumbs: true,
		},
		{
			id: 'documentTypes',
			title: 'Document Types',
			type: 'item',
			url: '/documentTypes',
			icon: icons.IconOccupation,
			breadcrumbs: true,
		},
	],
};

export default documents;
